export default __webpack_public_path__ + "static/media/logo.b62b7717.png";